import { c as _c } from "react/compiler-runtime";
import AppContext from '@/contexts/appContext';
import useResizeObserver from '@react-hook/resize-observer';
import { use, useLayoutEffect, useState } from 'react';
const initialRect = {
    width: 0,
    height: 0
};
const useElementSize = (target) => {
    const $ = _c(13);
    const { height: appHeight, width: appWidth } = use(AppContext);
    const [element, setElement] = useState(null);
    const [rect, setRect] = useState(initialRect);
    let t0;
    if ($[0] !== element) {
        t0 = () => {
            if (element && element.getBoundingClientRect) {
                const newRect = element.getBoundingClientRect().toJSON();
                setRect(newRect);
            }
        };
        $[0] = element;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    const handleUpdateRect = t0;
    let t1;
    let t2;
    if ($[2] !== target) {
        t1 = () => {
            if (target) {
                let el = null;
                if ("current" in target && target.current) {
                    el = target.current;
                }
                else {
                    if (target) {
                        el = target;
                    }
                }
                setElement(el);
            }
        };
        t2 = [target];
        $[2] = target;
        $[3] = t1;
        $[4] = t2;
    }
    else {
        t1 = $[3];
        t2 = $[4];
    }
    useLayoutEffect(t1, t2);
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (entry) => {
            if (entry.target.getBoundingClientRect) {
                const rect_0 = entry.target.getBoundingClientRect().toJSON();
                setRect(rect_0);
            }
        };
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    useResizeObserver(element, t3);
    let t4;
    if ($[6] !== appHeight || $[7] !== appWidth || $[8] !== handleUpdateRect) {
        t4 = [
            handleUpdateRect,
            appHeight,
            appWidth
        ];
        $[6] = appHeight;
        $[7] = appWidth;
        $[8] = handleUpdateRect;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    useLayoutEffect(handleUpdateRect, t4);
    const { width, height } = rect;
    let t5;
    if ($[10] !== height || $[11] !== width) {
        t5 = { width, height };
        $[10] = height;
        $[11] = width;
        $[12] = t5;
    }
    else {
        t5 = $[12];
    }
    return t5;
};
export default useElementSize;
